//#region src/lib/constants.ts
var e = [
	"themeMode",
	"language",
	"timezone"
], t = {
	themeMode: "theme",
	language: "locale",
	timezone: "timezone"
}, n = "prefs_owner", r = {
	themeMode: "theme",
	language: "locale"
};
//#endregion
export { r as i, t as n, e as r, n as t };
